import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { UnreadActivityNotificationsBadge } from '../../badges.react-component';
import { useActivityNotificationsStore } from '../../hooks/use-activity-notifications-store';
import { useHeaderStore } from '../../hooks/use-header-store';
import styles from "../desktop-header.module.css";
import { HeaderDropdown, HeaderButton, HeaderMenu } from '../header-dropdown.react-component';
import { NotificationItems } from './notification-items.react-component';
export const NotificationDropdown = observer(({
  className
}) => {
  const activityNotificationsStore = useActivityNotificationsStore();
  const headerStore = useHeaderStore();
  const {
    gettext
  } = useI18n();
  const badge = /*#__PURE__*/React.createElement(UnreadActivityNotificationsBadge, {
    dot: true,
    className: styles['dropdown-dot-badge']
  });
  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    trigger: /*#__PURE__*/React.createElement(HeaderButton, {
      componentClass: "a",
      href: headerStore.urls.VIEW_NOTIFICATIONS,
      udStyle: "icon",
      overlaychildren: badge
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "notification",
      color: "neutral",
      label: gettext('Notifications')
    })),
    className: className,
    onFirstOpen: activityNotificationsStore.initializeNotifications
  }, /*#__PURE__*/React.createElement(HeaderMenu, null, /*#__PURE__*/React.createElement(NotificationItems, null)));
});
//# sourceMappingURL=notification-dropdown.react-component.js.map